import { initialErrors } from '../Constants/Provinces.constants';
import { Types } from '../Constants/Types';
import ProvinceType from '../Interfaces/provinces.interface';

const ProvincesReducer = (state: ProvinceType['status'] = {
  province: undefined,
  provinces: [],
  lprovinces: false,
  lprovince: false,
  ldelete: false,
  error: initialErrors,
  pages: 0,
  total: 0
}, action: ProvinceType['action']) => {
  
  switch (action.type) {
    
    case Types.FETCH_PROVINCES:
      return { ...state, provinces: action.payload, pages: action.pages, total: action.total };

    case Types.FETCH_PROVINCE:
      return { ...state, province: action.payload };

    case Types.CREATE_PROVINCE:
      return { ...state, provinces: [action.payload, ...state.provinces] };
    
    case Types.DELETE_PROVINCE:
      return {
        ...state,
        provinces: state.provinces.filter(province => province._id !== action.payload)
      };

    case Types.UPDATE_PROVINCE:
      return { 
        ...state, 
        provinces: state.provinces.map(province => 
          province._id === action.payload._id ? action.payload : province
        )
      };

    case Types.TOGGLE_PROVINCE_ACTIVE:
      return {
        ...state,
        provinces: state.provinces.map(province =>
          province._id === action.payload.id 
            ? { ...province, isActive: action.payload.isActive }
            : province
        )
      };

    case Types.START_PROVINCES:
      return { ...state, lprovinces: true };

    case Types.END_PROVINCES:
      return { ...state, lprovinces: false };

    case Types.START_PROVINCE:
      return { ...state, lprovince: true };

    case Types.END_PROVINCE:
      return { ...state, lprovince: false };

    case Types.ERROR_PROVINCE:
      return { 
        ...state, 
        error: action?.payload ? { ...state.error, [action?.field!]: action.payload } : { ...state.error, [action?.field!]: null }
      };

    case Types.RESET_PROVINCE:
      return { ...state, error: initialErrors };

    default: 
      return state;
  }
};

export default ProvincesReducer;
